import type { UseQueryOptions, UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import type { IQueryKeyFactory } from '~/helpers/types';
import type { ApiError } from '~/lib/api';
import type { IApiGetCurrentFeaturePlanResponseBody } from '../AppsApi.types';
import { useApi } from '~/lib/api/useApi';

export type IUseAppCurrentFeaturePlanQueryValues = {
  appId: string;
};

export const appCurrentFeaturePlanQueryKeyFactory: IQueryKeyFactory<
  IUseAppCurrentFeaturePlanQueryValues
> = (values) => values && (['currentFeaturePlan', values.appId] as const);

export const useAppCurrentFeaturePlanQuery = (
  values?: IUseAppCurrentFeaturePlanQueryValues,
  options?: UseQueryOptions<IApiGetCurrentFeaturePlanResponseBody, ApiError>,
): UseQueryResult<IApiGetCurrentFeaturePlanResponseBody, ApiError> => {
  const api = useApi();

  return useQuery({
    queryKey: appCurrentFeaturePlanQueryKeyFactory(values),
    queryFn: values
      ? () => api.apps.getCurrentFeaturePlan(values.appId)
      : undefined,
    enabled: !!values,
    ...options,
  });
};
